import { Component, ViewChild, TemplateRef, ElementRef, OnInit } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { messageService } from 'src/app/message.service';
import { qmsService } from '../qms.service';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';
import { PaginationService } from 'src/app/PaginationService';
import { forkJoin } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { DynamicAuditTrailComponent } from 'src/app/support/dynamic-audit-trail/dynamic-audit-trail.component';
import { ExcelPdfComponent } from 'src/app/support/excel-pdf/excel-pdf.component';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import { GridReorderComponent } from 'src/app/grid-reorder/grid-reorder.component';
import { SearchUsersComponent } from '../search-users/search-users.component';
import { EditorComponent } from 'src/app/editor/editor.component';

export interface PopupData {
  title: string;
}

@Component({
  selector: 'app-location-master',
  templateUrl: './location-master.component.html',
  styleUrls: ['./location-master.component.scss']
})

export class LocationMasterComponent implements OnInit {

  isProcessing = true;
  locationData: any = {};
  auditTrail: any = {};
  visibleAuditTrail: boolean = false;

  applicableGroupsSearchText: any;
  selectedApplicableGroups: any = [];
  applicableGroupsDropdown: any = [];
  dropdownForApplicableGroups: any = [];


  constructor(public dialog: MatDialog, private readonly appService: AppService, public router: Router,
    private readonly snackBar: MatSnackBar, public message: messageService, private readonly elem: ElementRef,
    public qmsservice: qmsService, public paginationService: PaginationService) {
  }

  selectedAdditionalNotificationUserList: any = [];
  selectedLocationStatus: any = null;
  selectedLocationDepartment: any = [];
  selectedLocationServices: any = null;

  dropdownForQmsUsers: any = [];
  dropdownForLocationStatus: any = [];
  dropdownForLocationDepartment: any = [];
  dropdownForLocationServices: any = [];

  qmsUsersDropdown: any = [];
  locationStatusDropdown: any = [];
  locationDepartmentDropdown: any = [];
  locationServicesDropdown: any = [];
  oddLocationStatus: any = null;
  oddPointofContact: any = null;
  oddLocationService: any = null;

  qualityUsers: any = {};
  htmlContent: any;
  @ViewChild(EditorComponent) editorComponent!: EditorComponent;
  getClobData(list: any, colunName: any, popupColumnName: any) {
    this.isProcessing = true;
    let docObj = {

      primeIdentifier: list.PRIM_IDENTIFIER,
      tableView: list.tablevwname,
      columnName: colunName
    }
    this.htmlContent = "";
    this.appService.getClobToViewAudit(docObj).subscribe({
      next: (Response: any) => {
        this.htmlContent = Response.result;
        this.editorComponent.openEditor(this.htmlContent, popupColumnName);
      }, error: (error) => {
        throw error
      }
    })
    this.isProcessing = false;

  }

  ngOnInit() {
    this.isProcessing = true;

    const getUserPrivList$ = this.appService.getModuleBasedPrivilegedUsersList('QMS');
    const getLocationStatus$ = this.appService.getCodeListsByGroup('LOCATION_STATUS');
    const getLocationDepartment$ = this.appService.getCodeListsByGroup('LOCATION_DEPARTMENT');
    const getLocationServices$ = this.appService.getCodeListsByGroup('LOCATION_SERVICES');
    const getModuleBasedGroups$ = this.appService.getQmsGroupsByModule('CC');

    forkJoin([
      getUserPrivList$,
      getLocationStatus$,
      getLocationDepartment$,
      getLocationServices$,
      getModuleBasedGroups$
    ]).pipe(
      catchError(error => {
        console.error('An error occurred', error);
        this.isProcessing = false;
        // Handle error specific actions if needed
        return []; // Return an empty array or a default value as needed
      })
    ).subscribe({
      next: ([userPrivData, locationStatusData, locationDepartmentData, locationServicesData, ccGroups]) => {

        this.dropdownForQmsUsers = userPrivData;
        this.selectBoxForQmsUsers();

        this.dropdownForLocationStatus = locationStatusData;
        this.selectBoxForLocationStatus();

        this.dropdownForLocationDepartment = locationDepartmentData;
        this.selectBoxForLocationDepartment();

        this.dropdownForLocationServices = locationServicesData;
        this.selectBoxForLocationServices();

        this.dropdownForApplicableGroups = ccGroups;
        this.selectBoxForApplicableGroups();

        this.getcallMethod();
        this.isProcessing = false;
      }
    });
  }

  selectBoxForApplicableGroups() {
    this.applicableGroupsDropdown = [];
    this.applicableGroupsDropdown = this.dropdownForApplicableGroups?.map((item: any) => ({
      valueExp: item.groupId,
      displayExp: item.groupName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.trim()?.localeCompare(n?.displayExp?.trim())) || []
  }

  @ViewChild('applicableGroups') applicableGroups: MatSelect;
  isApplicableGroupsSelected = false;

  onApplicableGroupSelect(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => { this.isApplicableGroupsSelected = this.applicableGroupsDropdown.length == this.selectedApplicableGroups.length; })
    }
  }

  focusmethod(value: any) {
    setTimeout(() => {
      let requiredElement = document.getElementById(value);
      requiredElement?.focus();
    }, 0)
  }

  focusSearch(value: any) {
    setTimeout(() => {
      let searchBox = document.getElementById(value);
      searchBox?.focus();
    }, 0)
  }
  selectBoxForQmsUsers() {
    this.qmsUsersDropdown = [];
    this.qmsUsersDropdown = this.dropdownForQmsUsers?.map((qualityUser: any) => ({
      valueExp: qualityUser.userId,
      displayExp: qualityUser.userName
    })) || []
  }


  selectBoxForLocationStatus() {
    this.locationStatusDropdown = [];
    this.locationStatusDropdown = this.dropdownForLocationStatus?.map((item: any) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName
    })) || []
  }

  locationStatussearchTxt: any;
  onLocationStatusSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (event.source._selected) {
        setTimeout(() => { this.handleDropDownValidation('location-status-validation', this.selectedLocationStatus); })
      }
    }
  }

  selectBoxForLocationDepartment() {
    this.locationDepartmentDropdown = [];
    this.locationDepartmentDropdown = this.dropdownForLocationDepartment?.map((item: any) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName
    })) || []
  }

  @ViewChild('department') department: MatSelect;
  @ViewChild('addNotiUserList') addNotiUserList: MatSelect;

  isDepartmentSearchSelected = false;
  isAddNotiUserListSelected = false;

  toggleAllSelection(value: any) {
    if (value == 'department') {
      if (this.isDepartmentSearchSelected) this.department.options.forEach((item: MatOption) => item.select());
      else this.department.options.forEach((item: MatOption) => item.deselect());
    } else if (value == 'addNotiUserList')
      if (this.isAddNotiUserListSelected) this.addNotiUserList.options.forEach((item: MatOption) => item.select());
      else this.addNotiUserList.options.forEach((item: MatOption) => item.deselect());
  }


  departmentSearchText: any;
  onLocationDepartmentSelect(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => {
        this.isDepartmentSearchSelected = this.locationDepartmentDropdown.length == this.selectedLocationDepartment.length;
        this.handleDropDownValidation('location-department-validation', this.selectedLocationDepartment);
      })
    }
  }

  addNotiUserListSearchText: any;
  onAddNotiUserListSelectAll(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => { this.isAddNotiUserListSelected = this.qmsUsersDropdown.length == this.selectedAdditionalNotificationUserList.length; })

    }
  }

  serviceDeliveredsearchTxt: any;




  selectBoxForLocationServices() {
    this.locationServicesDropdown = [];
    this.locationServicesDropdown = this.dropdownForLocationServices?.map((item: any) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName
    })) || []
  }

  validateNoFields(event: KeyboardEvent) {
    const forbiddenKeys = ['E', 'e', '-', '*', '.', '+'];
    if (forbiddenKeys.includes(event.key)) {
      event.preventDefault();
    }
  }

  handleDropDownValidation(fieldId: string, selectedItems: any[]) {
    const field = document.getElementById(fieldId) as HTMLInputElement;
    field.style.color = selectedItems.length === 0 && field ? 'red' : '';
  }

  onNgModelChange(items: any, fieldId: string) {
    const field = document.getElementById(fieldId) as HTMLInputElement;
    field.style.color = items ? '#005c8a' : 'red';
  }

  fieldValidation(elementIds: string[]) {
    elementIds.forEach((elementId) => {
      const element = document.getElementById(elementId) as HTMLInputElement;
      element.style.color = 'red';
    });
  }

  singleSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: false,
    allowSearchFilter: true,
    singleSelection: true,
    itemsShowLimit: 1,
    closeDropDownOnSelection: true,
  };

  multiSelectDropdownSetting: IDropdownSettings = {
    ...this.singleSelectDropdownSetting,
    enableCheckAll: true,
    singleSelection: false,
    itemsShowLimit: 3,
    closeDropDownOnSelection: false,
  };

  popupDataTitle: PopupData = {
    title: ''
  };

  popupTitle: string | null = 'title';
  @ViewChild('addAndEditPopup', { static: true }) addAndEditPopup: TemplateRef<any>;
  visibleAddAndEditPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('deletePopup', { static: true }) deletePopup: TemplateRef<any>;
  visibleDeletePopup: MatDialogRef<TemplateRef<any>>;

  addAndEditPopupConfig = {
    width: '75%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '60px' },
  };

  deletePopupConfig = {
    width: '600px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };

  visibleAddButton: boolean;
  visibleEditButton: boolean;
  operationFlag: any;

  clearPopup() {
    [
      this.locationData.pointOfContact,
      this.selectedAdditionalNotificationUserList,
      this.selectedLocationStatus,
      this.selectedLocationDepartment,
      this.selectedLocationServices
    ] = [null, [], null, [], null];
    [
      this.locationData.locationCode,
      this.locationData.locationName,
      this.locationData.locationAddress,
      this.locationData.comments,
      this.locationData.pointOfContactName
    ] = [null, "", "", "", ""];
  }

  openAddPopup() {
    this.visibleAddButton = true;
    this.visibleEditButton = false;
    this.operationFlag = 'ADD';
    this.popupDataTitle.title = "Add Location";
    this.clearPopup();
    setTimeout(() => { this.isAddNotiUserListSelected = this.qmsUsersDropdown.length == this.selectedAdditionalNotificationUserList.length; })
    setTimeout(() => { this.isDepartmentSearchSelected = this.locationDepartmentDropdown.length == this.selectedLocationDepartment.length; })
    this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
  }

  editingLocationId: any;
  openEditPopup(editingData: any) {
    this.isProcessing = true;
    this.visibleAddButton = false;
    this.visibleEditButton = true;
    this.operationFlag = 'EDIT';
    this.popupDataTitle.title = "Edit Location";
    this.clearPopup();
    this.editingLocationId = editingData.LOCATION_ID;
    this.appService.getLocationByLocationId(this.editingLocationId).subscribe((data: any) => {
      if (data.additionalNotificationUserList) {
        this.selectedAdditionalNotificationUserList = data.additionalNotificationUserList.split(',').map(Number);
        setTimeout(() => { data.additionalNotificationUserList.split(',').length == this.dropdownForQmsUsers.length && this.addNotiUserList.options.forEach((item: MatOption) => item.select()); })
      }

      if (data.locationStatus) {
        const matchingStatus = this.dropdownForLocationStatus?.find((item: any) => item.codelistCode == data.locationStatus);
        if (!matchingStatus) {
          this.oddLocationStatus = data.locationStatus;
          this.locationStatusDropdown.push({
            valueExp: data.locationStatus,
            displayExp: data.locationStatus
          })
        }
        this.selectedLocationStatus = data.locationStatus;
      }
      if (data.departments) {
        this.selectedLocationDepartment = data.departments.split(',');
        setTimeout(() => { data.departments.split(',').length == this.dropdownForLocationDepartment.length && this.department.options.forEach((item: MatOption) => item.select()); })
      }

      if (data.seriviceDelivered) {
        const matchingServiceDelivered = this.dropdownForLocationServices?.find((item: any) => item.codelistCode == data.seriviceDelivered);
        if (!matchingServiceDelivered) {
          this.oddLocationService = data.seriviceDelivered;
          this.locationServicesDropdown.push({
            valueExp: data.seriviceDelivered,
            displayExp: data.seriviceDelivered
          })
        }
        this.selectedLocationServices = data.seriviceDelivered;
      }


      this.locationData = data;
      this.locationData.comments = '';
      this.isProcessing = false;
      if (!this.isProcessing) {
        this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
      }
    })
  }

  deletingLocationId: any;
  openDeletePopup(deletingData: any) {
    this.operationFlag = 'DELETE';
    this.popupDataTitle.title = "Delete Location";
    this.deletingLocationId = deletingData.LOCATION_ID;
    this.locationData.deleteReason = "";
    this.visibleDeletePopup = this.dialog.open(this.deletePopup, this.deletePopupConfig);
  }

  addAndEditFunction(locationParam: any) {

    const validations = [
      { condition: !locationParam.locationCode, id: 'location-code-validation' },
      { condition: !locationParam.locationName, id: 'location-name-validation' },
      { condition: !locationParam.locationAddress, id: 'location-address-validation' },
      { condition: !this.selectedLocationStatus, id: 'location-status-validation' },
      { condition: !locationParam.pointOfContact, id: 'point-of-contact-validation' },
      { condition: this.selectedLocationDepartment?.length < 1, id: 'location-department-validation' },
      { condition: this.visibleEditButton && !this.locationData.comments, id: 'comments-validation' },
    ]

    const invalidIds = validations.filter((validation) => validation.condition).map((validation) => validation.id);

    if (invalidIds.length > 0) {
      this.fieldValidation(invalidIds);
    } else {
      this.isProcessing = true;
      const data = {
        locationCode: locationParam.locationCode,
        locationName: locationParam.locationName,
        locationAddress: locationParam.locationAddress,
        pointOfContact: locationParam.pointOfContact ?? null,
        additionalNotificationUserList: this.selectedAdditionalNotificationUserList?.join(','),
        locationStatus: this.selectedLocationStatus ?? null,
        departments: this.selectedLocationDepartment?.join(','),
        seriviceDelivered: this.selectedLocationServices ?? null,
        comments: locationParam.comments,
        //applicableGroups: this.selectedApplicableGroups?.join(','),
      }

      if (this.operationFlag == 'ADD') {
        this.appService.createLocation(data).subscribe({
          next: (Response: any) => {
            if (Response.resultType == "S") {
              this.ngOnInit();
              this.getcallMethod();
              this.visibleAddAndEditPopup.close();
              this.showSnackBar(Response.result, Response.resultType);
            } else {
              this.isProcessing = false;
              this.showSnackBar(Response.result, Response.resultType);
            }
          },
          error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });
      } else {
        const modifiedData = {
          ...data,
          locationId: this.editingLocationId
        }
        this.appService.updateLocation(modifiedData).subscribe({
          next: (Response: any) => {
            if (Response.resultType == "S") {
              this.ngOnInit();
              this.getcallMethod();
              this.visibleAddAndEditPopup.close();
              this.showSnackBar(Response.result, Response.resultType);
            } else {
              this.isProcessing = false;
              this.showSnackBar(Response.result, Response.resultType);
            }
          },
          error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });
      }
    }
  }

  cancelAddAndEditFunction() {
    this.visibleAddAndEditPopup.close();
  }

  deleteFunction(locationParam: any) {
    if (locationParam.deleteReason) {
      this.isProcessing = true;
      const data = {
        locationId: this.deletingLocationId,
        locationCode: locationParam.locationCode,
        locationName: locationParam.locationName,
        deleteReason: locationParam.deleteReason
      }

      this.appService.deleteLocation(data).subscribe({
        next: (Response: any) => {
          if (Response.resultType == "S") {
            this.ngOnInit();
            this.getcallMethod();
            this.visibleDeletePopup.close();
            this.showSnackBar(Response.result, Response.resultType);
          } else {
            this.isProcessing = false;
            this.showSnackBar(Response.result, Response.resultType);
          }
        },
        error: (error) => {
          this.isProcessing = false;
          throw error;
        }
      });
    } else {
      const field = document.getElementById('delete-reason-validation') as HTMLInputElement;
      field.style.color = 'red';
    }
  }

  cancelDeleteFunction() {
    this.visibleDeletePopup.close();
  }

  showSnackBar(message: string, type: string) {
    const sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: this.message.breadcrumbData.thirdLevel ? this.message.breadcrumbData.thirdLevel : this.message.breadcrumbData.secondLevel,
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });

    sb.onAction().subscribe(() => {
      sb.dismiss();
    });
  }

  searchText: any;
  searchValue: any;
  _temp: any = {};
  columnLists: any = {};
  gridData: any = [];
  tempGridData: any;
  makeStickyColumns: any;
  dataTypeList: any = [];
  visibleDataGrid: boolean = false;
  itemsPerPage = 5;
  currentPage = 1;
  totalPages = 0;
  maxSize = 3;
  collectionSize: number;
  perPage = 10;
  calculateTotalPages: number;
  showingResultsText = "Showing results";
  displayingClaimsText = "Displaying claims";
  rowText = "Rows";
  showingRowsText = "Showing rows";
  pager: any = {};
  pagedItems: any[];
  error = '';

  getcallMethod() {
    this.isProcessing = true;
    setTimeout(() => {
      this.isProcessing = false;
    }, 3000);
    const data = {

      gridName: "LOCATION_MASTER",
    }
    this.appService.getDynamicGridHeaders(data).subscribe({
      next: (response: any) => {
        response.orderByClause = response.orderByClause ? response.orderByClause : "";
        this.makeStickyColumns = response.fixedFieldCnt;
        const data1: any = {

          gridName: "QMS_LOCATION_MASTER_VW",
          tableOrViewName: response.tableOrViewName ?? "",
          columnsList: response.columnsList ?? "",
          fieldLabelsList: response.fieldLabelsList ?? "",
          invisibleColumn: response.invisibleColumn ?? "",
          orderByClause: response.orderByClause ?? "",
          fieldSizeList: response.fieldSizeList ?? "",
          columnsListarray: [],
          fieldColumnarray: [],
          invisibleColumnarray: [],
          fieldSizeListArray: [],
          clobColumnlist: response.closblist || "",
          blobColumnlist: response.bloblist || ""
        }
        this.reportObj = { ...data1, ...data };
        this.appService.getDynamicGridData(data1).subscribe({
          next: (response1: any) => {
            this.gridData = response1;
            this.visibleAuditTrail = false;
            data1.columnsListarray = data1.columnsList.split(",");
            data1.fieldColumnarray = data1.fieldLabelsList.split(",");
            data1.invisibleColumnarray = data1.invisibleColumn.split(",");
            data1.fieldSizeListArray = data1.fieldSizeList.split(",");
            this.columnLists.columnsListarray = data1.columnsListarray;
            this.columnLists.fieldLabelsList = data1.fieldLabelsList;
            this.columnLists.fieldColumnarray = [];
            for (let p = 0; p < data1.fieldColumnarray.length; p++) {
              this.columnLists.fieldColumnarray.push({
                "fieldColumnarray": data1.fieldColumnarray[p],
                "width": data1.fieldSizeListArray[p] + 'px'
              })
            }
            this.columnLists.invisibleColumnarray = data1.invisibleColumnarray;
            this.columnLists.fieldSizeListArray = [];
            for (const element of data1.fieldSizeListArray) {
              this.columnLists.fieldSizeListArray.push(element + 'px');
            }
            for (let y = 0; y < this.columnLists.columnsListarray.length; y++) {
              for (const element of this.columnLists.invisibleColumnarray) {
                if (this.columnLists.columnsListarray[y] == element) {
                  this.columnLists.columnsListarray.splice(y, 1);
                  this.columnLists.fieldColumnarray.splice(y, 1);
                  this.columnLists.fieldSizeListArray.splice(y, 1);
                }
              }
            }
            let tableData = {
              tablename: data1.tableOrViewName
            };
            this.columnLists.columnsListarray1 = [];
            this.appService.tableFieldsDataType(tableData).subscribe((response2: any) => {
              this.dataTypeList = response2;
              for (let m = 0; m < this.columnLists.columnsListarray.length; m++) {
                this.columnLists.columnsListarray1.push({});
                this.columnLists.columnsListarray1[m].columnsListarray = this.columnLists.columnsListarray[m];
                this.columnLists.columnsListarray1[m].dataType = "textbox";
                this.columnLists.columnsListarray1[m].width = this.columnLists.fieldSizeListArray;
                for (const element of this.dataTypeList) {
                  if (element.columnName == this.columnLists.columnsListarray[m]) {
                    this.columnLists.columnsListarray1[m].dataType = element.fieldType;
                  }
                }
              }
              for (const row of this.gridData) {
                for (const element of this.dataTypeList) {
                  if (element.fieldType == 'CHECKBOX') {
                    row[element.columnName] = row[element.columnName] == "Y";
                  }
                }
              }
              this.calculateTotalPages = this.collectionSize / this.perPage;
              this.pager.totalPages = undefined;
              this.setPage(1, 0);
            });
            this.message.gridList = this.gridData;
            this.collectionSize = this.gridData.length;
            this.totalPages = Math.ceil(this.gridData.length / this.itemsPerPage);
            this.isProcessing = false;
            this.labelCall();
          }, error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });
        this.isProcessing = false;
      }, error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  setPage(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }
    this.pager = this.paginationService.getPager(this.gridData.length, page, this.perPage, targetpage);
    this.pagedItems = this.gridData.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }

  setPagedorserch(page: number, targetpage: number) {
    if (Number.isNaN(page)) {
      page = 1;
    }

    if (this.tempGridData.length > 0) {
      this.pager = this.paginationService.getPager(this.tempGridData.length, page, this.perPage, targetpage);
      this.pagedItems = this.tempGridData.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = [];
    }
  }

  paginationCall(value: number) {
    this.perPage = value;
    this.setPage(this.pager.currentPage, 0);
  }

  applyFilter3(column: string, event: Event): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.pagedItems = this.gridData.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = this.gridData.filter((item: any) =>
        item[column]?.toLowerCase().includes(filter)
      );
    }
  }

  searchValue2: any;
  applyFilter2(event: Event) {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.tempGridData = this.gridData;
      this.pager = this.paginationService.getPager(this.tempGridData.length, 1, this.perPage, 0);
      this.pagedItems = this.tempGridData.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      if (this.gridData == undefined) {
        return this.gridData;
      }
      if (!this.gridData.length) {
        return this.gridData;
      }
      if (filter) {
        this.tempGridData = this.gridData.filter(function (item: any) {
          return JSON.stringify(item).toLowerCase().includes(filter);
        });
      } else {
        this.tempGridData = this.gridData.filter(function (item: any) {
          return JSON.stringify(item).toLowerCase();
        });
      }
      this.setPagedorserch(1, 0);
    }
  }

  sortedColumn: string = '';
  sortDirection: string = 'asc';
  sortColumn(column: string, list: any) {
    if (column === this.sortedColumn) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortedColumn = column;
      this.sortDirection = 'asc';
    }
    list.showsort = this.sortDirection;
    this.gridData.sort((a: { [x: string]: any; }, b: { [x: string]: any; }) => {
      const key = column;
      const valueA = a[key];
      const valueB = b[key];

      if (valueA < valueB) {
        return this.sortDirection === 'asc' ? -1 : 1;
      } else if (valueA > valueB) {
        return this.sortDirection === 'asc' ? 1 : -1;
      } else {
        return 0;
      }
    });
    this.setPage(1, 0);
  }

  counts: any;
  cssfunction(ix: number) {
    let elements1 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-col1');
    let index1 = 1;
    let headerWidth = 0;
    elements1.forEach((header: any, key: any) => {
      for (let i = 1; i <= this.makeStickyColumns; i++) {
        if (index1 == i) {
          header.style.position = 'sticky';
          header.style.background = 'white';
          if (index1 > 1) {
            headerWidth += 200;
            header.style.left = headerWidth + 'px';
          } else {
            headerWidth = 60;
            header.style.left = headerWidth + 'px';
          }
        }
      }
      index1++;
    })
    let elements2 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-row1');
    let index2 = 1;
    let lengthOfColumns = this.columnLists.columnsListarray1.length;
    let colWidth = 0;
    let p = 1;
    elements2.forEach((column: any, key: any) => {
      for (let j = 1; j <= this.makeStickyColumns; j++) {
        if (index2 == j) {
          column.style.position = 'sticky';
          p = p + 1;
          if (index2 > 1) {
            colWidth += 200;
            let previousColumn = elements2[key - 1];
            console.log(previousColumn.style.width);
            column.style.left = colWidth + 'px';
          } else {
            colWidth = 60;
            column.style.left = colWidth + 'px';
          }
          column.addEventListener('click', this.onClick.bind(this));
        }
      }
      if (index2 == (lengthOfColumns - 1)) {
        index2 = 0;
      } else {
        index2++;
      }
    })
  }

  onClick(event: any) {

  }

  parentCheckBox: boolean = false;
  childCheckBoxs: boolean = false;
  dataGridParentCheckBoxChecked(e: any) {
    if (e.target.checked) {
      this.childCheckBoxs = true;
      for (const element of this.gridData) {
        element.childCheckBoxs = true;
      }
    } else {
      this.childCheckBoxs = false;
      for (const element of this.gridData) {
        element.childCheckBoxs = false;
      }
    }
  }

  previousSelectedValue: any;
  dataGridChildCheckBoxChecked(e: any, list: any, idx: any) {
    if (e.target.checked) {
      if (this.previousSelectedValue != undefined) {
        this.gridData[this.previousSelectedValue].childCheckBoxs = false;
      }
      list.childCheckBoxs = true;
      this.auditTrail.refNo = list.LOCATION_CODE;
    } else {
      list.childCheckBoxs = false;
    }
    this.previousSelectedValue = idx;
    this.visibleAuditTrail = this.gridData.some((list: any) => list.childCheckBoxs);
  }

  refreshGridData() {
    this.getcallMethod();
  }

  @ViewChild(DynamicAuditTrailComponent) dynamicAuditTrailComponent!: DynamicAuditTrailComponent;

  openAuditTrail(viewType: any, location: any) {
    this.auditTrail.refNo = viewType == 'overAll' ? null : location.LOCATION_CODE;
    this.auditTrail.gridName = 'LOCATION_MASTER';
    this.auditTrail.report_And_Popup_Name = 'Location Master Audit Trail';
    this.dynamicAuditTrailComponent.triggerTrail(location);
  }

  @ViewChild(ExcelPdfComponent) excelPdfComponent!: ExcelPdfComponent;
  excelPdf: any = {};
  reportObj: any = {};

  openReport(reportType: string) {
    this.excelPdf.reportObj = this.reportObj;
    this.excelPdf.reportType = 'Dynamic';
    this.excelPdf.reportName = 'Location Master Report';
    this.excelPdf.dropDown = this.columnLists?.fieldColumnarray?.map((item: any) => item.fieldColumnarray);
    this.excelPdfComponent.openReportPopup(reportType);
  }

  @ViewChild(GridReorderComponent) gridReorderComponent!: GridReorderComponent;
  openReorder() {
    this.gridReorderComponent.reordercall(this.reportObj.gridName, this.reportObj.tableOrViewName, null, 0)
  }

  onChildValueEmitted() {
    this.getcallMethod();
  };

  dynamicLabel: any = null;
  label: any = [];
  labelCall() {
    this.isProcessing = true;
    const data = {
      tableName: this.reportObj.tableOrViewName,
      moduleName: null,
      gridName: this.reportObj.gridName,
      groupId: 0,
    };
    this.appService.getreorderGirdColumnList(data).subscribe({
      next: (data: any) => {
        this.label = data;
        this.dynamicLabel = this.label.reduce((acc: any, user: any) => {
          acc[`${user.columnName}`] = user.changedFieldName;
          return acc;
        }, {});
        this.isProcessing = false;
      }, error: (error: any) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  @ViewChild(SearchUsersComponent) searchUsersComponent!: SearchUsersComponent;
  searchPointOfContact(workingFor: string) {
    this.searchUsersComponent.popupTitle = 'Point Of Contact';
    this.searchUsersComponent.isSwitchingUser = workingFor == 'switch';
    this.searchUsersComponent.isSwitchingUser && (this.message.switchUserCurrentValue = this.locationData.pointOfContactName);
    this.searchUsersComponent.selectionMode = 'single';
    this.searchUsersComponent.trigger();
  }

  onSearchUserEmitted() {
    this.locationData.pointOfContact = this.qmsservice.selectedSearchUserId;
    this.locationData.pointOfContactName = this.qmsservice.selectedSearchUserName;
    if (this.searchUsersComponent.isSwitchingUser) {
      this.addAndEditFunction(this.locationData);
    }
  }

  public focusEmpty(): void {
    console.log();
  }
}
